import { SyntheticEvent } from 'react';
import { IconName } from '@optimus-web/icons';
import { Spacing } from '@optimus-web/local-tokens';
import AccordionBody from './AccordionBody';
import {
    AccordionContainerElement,
    AccordionHeaderElement,
    AccordionHeaderLabelElement,
    AccordionHeaderLeftElement,
    AccordionHeaderRightElement,
    AccordionIconButtonElement,
    AccordionPrimaryTextElement,
    AccordionSecondaryTextElement,
} from './style';

interface AccordionProps {
    expanded: boolean;
    onClick: () => void;
    body: React.ReactChild;
    beforeTextContent?: React.ReactChild;
    afterTextContent?: React.ReactChild;
    rightContent?: React.ReactChild;
    primaryText: React.ReactNode;
    secondaryText?: React.ReactNode;
    bodyPadding?: Spacing;
    withBodyBorder?: boolean;
}

const Accordion = ({
    expanded,
    onClick,
    beforeTextContent,
    afterTextContent,
    rightContent,
    primaryText,
    secondaryText,
    body,
    withBodyBorder = true,
    bodyPadding = 200,
    ...other
}: AccordionProps) => {
    const handleChildClick = (e: SyntheticEvent) => e.stopPropagation();

    return (
        <AccordionContainerElement {...other}>
            <AccordionHeaderElement onClick={onClick} data-test-accordion-header>
                {beforeTextContent ? (
                    <AccordionHeaderLeftElement onClick={handleChildClick}>
                        {beforeTextContent}
                    </AccordionHeaderLeftElement>
                ) : null}
                <AccordionHeaderLabelElement>
                    <div>
                        <AccordionPrimaryTextElement>{primaryText}</AccordionPrimaryTextElement>
                        {secondaryText ? (
                            <AccordionSecondaryTextElement>{secondaryText}</AccordionSecondaryTextElement>
                        ) : null}
                    </div>
                    {afterTextContent}
                </AccordionHeaderLabelElement>
                {rightContent ? (
                    <AccordionHeaderRightElement onClick={handleChildClick}>{rightContent}</AccordionHeaderRightElement>
                ) : null}
                <AccordionIconButtonElement
                    aria-label={expanded ? 'collapse' : 'expand'}
                    icon={IconName.ChevronDown}
                    expanded={expanded}
                    aria-expanded={expanded}
                />
            </AccordionHeaderElement>
            <AccordionBody
                expanded={expanded}
                withBodyBorder={withBodyBorder}
                bodyPadding={bodyPadding}
                data-test-accordion-body
            >
                {body}
            </AccordionBody>
        </AccordionContainerElement>
    );
};

export default Accordion;
